'use client';

import { useTranslations } from 'next-intl';

interface ArchiveHeaderProps {
  totalCount: number;
  searchQuery: string;
  memberFilters: string[];
  platformFilters: string[];
  yearFilters: string[];
}

export default function ArchiveHeader({
  totalCount,
  searchQuery,
  memberFilters,
  platformFilters,
  yearFilters,
}: ArchiveHeaderProps) {
  const t = useTranslations('archive');

  return (
    <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 md:gap-6 mb-6 md:mb-8">
      <div>
        <h1 className="text-2xl md:text-4xl font-bold tracking-wide text-[#F5F5F0] mb-1 md:mb-2 font-en">
          {t('title')}
        </h1>
        <p className="text-xs md:text-sm text-[#888888]">
          {t('postsCount', { count: totalCount.toLocaleString() })}
        </p>
      </div>

      {/* Search Box */}
      <form action="/archive" method="get" className="w-full md:w-auto">
        <div className="flex items-center gap-3 bg-[#1A1A1A] border border-white/10 rounded-lg px-4 md:px-5 py-2.5 md:py-3 w-full md:w-[280px]">
          <svg
            className="w-4 h-4 text-[#888888]"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>
          <input
            type="text"
            name="q"
            placeholder={t('searchPlaceholder')}
            defaultValue={searchQuery}
            className="bg-transparent text-sm text-[#F5F5F0] placeholder-[#666666] outline-none flex-1"
          />
          {memberFilters.length > 0 && <input type="hidden" name="member" value={memberFilters.join(',')} />}
          {platformFilters.length > 0 && <input type="hidden" name="platform" value={platformFilters.join(',')} />}
          {yearFilters.length > 0 && <input type="hidden" name="year" value={yearFilters.join(',')} />}
        </div>
      </form>
    </div>
  );
}
